import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Header from '../component/Header'
import LoanBenifit from '../component/LoanBenifit'
import Eligibilityandoc from '../component/Eligibilityandoc'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Footer from '../component/Footer';
import Representative from '../component/Representative';
import RateandTerms from '../component/RateandTerms';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import BoltIcon from '@mui/icons-material/Bolt';
import apply from '../assets/applythum.png'
import DescriptionIcon from '@mui/icons-material/Description';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import Login from '../pages/journey-pages/login';
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

export default function ApplyNow() {
  const [mobileNumber, setMobileNumber] = useState("");
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const customerDetails = useSelector((state) => state.customerJourneyDetails.customerDetails);
  const checklogin = customerDetails?.token;
  const navigate = useNavigate();

   useEffect(() => {

    if ((checklogin)) {
      navigate('/journey');
    }
  }, [checklogin])

  const handleGetOTP = () => {
    if (mobileNumber.length !== 10 || !agreedToTerms) {
      alert("Enter valid number & accept terms");
      return;
    }
    alert("OTP Sent!");
  };
  const documentRequirements = [
    {
      icon: <CurrencyRupeeIcon />,
      title: 'Completed Application Form',
      description: 'Fill in details accurately for quicker fund disbursement.',
      metadata: 'FORMAT: PDF/DOC',
    },
    {
      icon: <CurrencyRupeeIcon />,
      title: 'Passport-Size Photograph',
      description: 'A-4 size, clear, recent, white background. Digital copy required for e-KYC.',
      metadata: 'MAX SIZE: 2MB',
    },
    {
      icon: <CurrencyRupeeIcon />,
      title: 'Identity (ID) Proof',
      description: 'Aadhaar Card and PAN Card are mandatory for all loan categories.',
      metadata: '',
      badges: ['PAN', 'AADHAAR'],
    },
    {
      icon: <CurrencyRupeeIcon />,
      title: 'Address Proof',
      description: 'Voter ID, Driver\'s License, Passport, Utility Bill, or Rental Agreement.',
      metadata: 'LAST 3 MONTHS ONLY',
    },
    {
      icon: <CurrencyRupeeIcon />,
      title: 'Income Proof',
      description: 'Recent 3 months bank statement (salary account) and last 3 months salary slips.',
      metadata: 'MULTIPLE FILES ALLOWED',
    },
  ];
  return (
    <>
      <Header />

      <Login/>
      <Representative />

      <div className="max-w-7xl mx-auto ">
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-6 md:p-8">
          
          <div className="flex items-center ">
            <DescriptionIcon className="text-blue-600" />
            <h2 className="text-2xl font-bold text-gray-900">
              Terms & Conditions
            </h2>
          </div>

          <p className="text-gray-700 leading-relaxed mb-4">
            By clicking <strong>"I Agree"</strong> or <strong>"I Accept"</strong>,
            or by downloading, installing, or using our services, you acknowledge
            that you have read, understood, and agreed to be bound by the Terms &
            Conditions of  <Link to="https://kisgaleasing.com" target='_blank'>Kisga Leasing and Finance Pvt Ltd</Link>.
          </p>

          

          <div className="flex items-center justify-between flex-wrap gap-4 mt-6">
            

            <Link
              to="/terms-and-conditions"
              className="inline-flex items-center gap-1 text-blue-600 font-semibold hover:text-blue-800 transition-colors"
            >
              Read More
              <KeyboardArrowRightIcon fontSize="small" />
            </Link>
          </div>
        </div>
      </div>

      

      <LoanBenifit />
      <Eligibilityandoc />
      <div className="max-w-7xl mx-auto">

        <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-snug mb-2">
          Address &<span className='ms-text-secondary'> Accreditation </span>
        </h3>
        <p>Upon acceptance of your eligibility, the loan amount is disbursed to your account directly instantly.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-4 py-15 ">
          {documentRequirements.map((doc, index) => (
            <div
              key={index}
              className="bg-white border-2 border-gray-50 rounded-lg p-6 hover:shadow-lg transition-shadow"
            >
              <div className="w-12 h-12 bg-slate-900 rounded-lg flex items-center justify-center mb-4 text-white">
                {/* <doc.icon className="w-6 h-6 text-white" /> */}
                {doc.icon}
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">
                {doc.title}
              </h3>
              <p className="text-sm text-slate-600 mb-4 leading-relaxed">
                {doc.description}
              </p>
              <div className='' style={{ borderBottom: '1px solid #ddd' }}></div>
              {doc.badges && (
                <div className="flex gap-2 mt-3">
                  {doc.badges.map((badge, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-gray-100 text-xs  font-medium text-slate-700 rounded"
                    >
                      {badge}
                    </span>
                  ))}
                </div>
              )}
              {doc.metadata && (
                <p className="text-xs text-slate-400 uppercase tracking-wide mt-5">
                  {doc.metadata}
                </p>
              )}
            </div>
          ))}

          <div className="bg-gradient-to-br from-slate-800 to-teal-800 rounded-lg p-6 text-white flex flex-col justify-between">
            <div>
              <div className="w-12 h-12 bg-teal-500/30 rounded-full flex items-center justify-center mb-4">
                <SupportAgentIcon className="w-6 h-6 text-teal-300" />
              </div>
              <h3 className="text-xl font-semibold mb-3">Need Help?</h3>
              <p className="text-sm text-slate-300 mb-6 leading-relaxed">
                Our loan officers are available 24/7 to guide you through the document verification process.
              </p>
            </div>
           <Link to={'/contact-us'}> <button className="w-full bg-white text-slate-900 px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors">
              Speak with an Expert
            </button>
            </Link>
          </div>
        </div>
      </div>
      {/* <RateandTerms/> */}
      
      <Footer />

    </>
  )
}
